import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getSettingAdyenEligibleCountries } from "@faire/help-center-utils/settings/getSettingAdyenEligibleCountries";

export const usePaymentPayoutsArticles = () => {
  const articles = useArticles();
  const brand = getBrand();
  if (!brand || !brand.based_in) {
    return [];
  }
  if (getSettingAdyenEligibleCountries().includes(brand.based_in)) {
    if (brand?.based_in === "AUS") {
      return [articles.InvoicesAndBilling.PAYOUT_AUSTRALIAN];
    }
    return [articles.InvoicesAndBilling.PAYOUT_EUROPEAN];
  } else if (brand?.based_in === "CAN") {
    return [articles.InvoicesAndBilling.PAYOUT_CANADIAN];
  } else {
    return [articles.InvoicesAndBilling.SETTING_UP_PAYOUT];
  }
};
